import { defineStore } from "pinia";
import http from "@/http";
import { LIST_FATURAMENTO, ADD_FATURAMENTO, UPDATE_FATURAMENTO, DEL_FATURAMENTO } from "@/http/url";

export const useFaturamentoStore = defineStore("FaturamentoStore", {
  state: () => {
    return {
      faturamentos: [],
      total: Number(0.0),
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    //AÇÕES SOBRE OS VEICULOS
    LISTAR_FATURAMENTOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_FATURAMENTO)
          .then((response) => {
            this.faturamentos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_FATURAMENTO(faturamento) {
      return http
        .post(ADD_FATURAMENTO, faturamento)
        .then((response) => this.faturamentos.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_FATURAMENTO(faturamento) {
      return http
        .put(`${UPDATE_FATURAMENTO + faturamento.id}`, faturamento)
        .then((response) => {
          const index = this.faturamentos.findIndex((objeto) => objeto.id === response.data.id);
          this.faturamentos[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_FATURAMENTO(id) {
      return http
        .delete(`${DEL_FATURAMENTO + id}`)
        .then(() => (this.faturamentos = this.faturamentos.filter((object) => object.id != id)));
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getFaturamentos() {
      return this.faturamentos;
    },

    getTotal() {
      return this.total;
    },

    getFilterFaturamentos: (state) => {
      return (filtro) => {
        let filtrada = state.faturamentos;

        if (filtro.id != "") {
          filtrada = filtrada.filter((f) => !filtro || f.id == filtro.id);
        }

        if (filtro.pago != null) {
          filtrada = filtrada.filter((f) => !filtro || f.pago == filtro.pago);
        }

        filtrada = filtrada.filter(
          (obj) =>
            !filtro ||
            (obj.descricao.includes(filtro.descricao) &&
              obj.cliente.includes(filtro.cliente) &&
              obj.orcamento.includes(filtro.orcamento) &&
              obj.nota.includes(filtro.nota))
        );

        filtrada.forEach((fat) => {
          if (fat.pago) {
            fat._rowVariant = "success";
          }
        });

        let total = Number(0.0);
        filtrada.forEach((fat) => {
          total = total + parseFloat(fat.total);
        });
        state.total = parseFloat(total).toFixed(2);

        return filtrada;
      };
    },

    getPeriodoFaturamento: (state) => {
      return (periodo) => {
        let filtrada = state.faturamentos;
        filtrada = filtrada.filter(
          (faturamento) =>
            new Date(faturamento.data).getTime() >= new Date(periodo.inicio).getTime() &&
            new Date(faturamento.data).getTime() <= new Date(periodo.final).getTime()
        );

        let total = Number(0.0);
        filtrada.forEach((fat) => {
          total = total + parseFloat(fat.total);
        });
        state.total = parseFloat(total).toFixed(2);

        return filtrada;
      };
    },

    getFaturamentoLoad(state) {
      return state.loaded;
    },
  },
});
